import { useStyles } from '@webapps/styles';
import { resolvePath } from '@webapps/utils';
import PropTypes from 'prop-types';

import { TextFieldPx } from '..';

const FormikTextField = ({
  children,
  formik: { errors, handleChange, touched, values },
  name,
  borderRadius,
  startAdornment,
  onChange,
  completed,
  ...props
}) => {
  const {
    classes,
  } = useStyles(styles);

  return <TextFieldPx
    error={!!resolvePath(touched, name, '') && !!resolvePath(errors, name, '')}
    helperText={resolvePath(touched, name, '') && resolvePath(errors, name, '')}
    id={name}
    name={name}
    borderRadius={borderRadius}
    onChange={onChange || handleChange}
    value={resolvePath(values, name, '')}
    startAdornment={startAdornment}
    completed={completed}
    {...props}
  >
    {children}
  </TextFieldPx>
}

// C0D9FF

const styles = () => ({

});

FormikTextField.propTypes = {
  field: PropTypes.elementType,
  name: PropTypes.string,
  formik: PropTypes.object,
  children: PropTypes.node,
  onChange: PropTypes.func,
};

export default FormikTextField;